// extracted by mini-css-extract-plugin
export default {"columns":"Сurators_columns__YMKRq"};